
export const graphRoot = "https://graph.microsoft.com/v1.0";
export const sitename = "constructionsite";
export const listname = "List";
export const userListName = "EmployeeMaster";
export const ContractListName = "ClientMaster";
export const SiteListName = "List5";
export const PersonalInfoListName = "PersonalInformation";
export const PartnerMasterListName = "List3";
export const NewEntrySite = "NewEntryRecord1";

export const japaneseStrings = {
  months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
  shortMonths: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
  days: ['日曜日', '月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日'],
  shortDays: ['日', '月', '火', '水', '木', '金', '土'],
  goToToday: '今日へ',
};

// globals.ts
export const GlobalVars = {
  phoneNumber_enter: "",
  userid: "",
};


// Sample mock data (replace with real API later) - Need to delete
export const mockData = [
  {
    id: 1,
    date: "2025年8月1日",
    leader: "山田 太郎",
    foreman: "田中 花子",
    tasks: ["高所作業", "ホットワーク"],
    risks: ["安全帯を使用する", "消火器を近くに置いておく"],
  },
  {
    id: 2,
    date: "2025年8月1日",
    leader: "山田 太郎",
    foreman: "加藤 翔",
    tasks: ["閉鎖空間への立ち入り"],
    risks: ["空気の質をテストする"],
  },
];